<!-- left menu -->
<div class="left-menu-container">
    <div>
        <div class="icon-input-container">
            <input class="icon-input" placeholder="Search" type="text">
            <div class="icon-input-wrap">
                <img src="/assets/images/icons/search.svg" width="30px" height="30px">
            </div>
        </div>
    </div>
    <div><img src="/assets/images/icons/shopping-cart.png" style="width:22px;height: 22px;"></div>
    <div>
        <div class="nav-menu-item clear-hover-bg" style="padding: 0 !important;">
            <a class="menu-link nav-menu-center" href="#0" style="padding: 0 !important;">
                <img  src="/assets/images/icons/profile-unknown.svg" class="profile-menu-item">
            </a>
            <!-- <img class="menu-link nav-menu-center" src="unknown.svg" style="width:39px;height: 39px;background-color: #e6eed7;border-radius: 50%;"> -->
            <ol class="nav-sub-item-right" style="margin-block-start: 0;width: 170px;right:0px !important;z-index: 401;">
                <li class="nav-menu-item nav-menu-center nav-menu-seperator" >
                    <p class="text-ellipsis-1" style="padding-right:20px ;">Stein Inge bakke Haaland</p>
                </li>
                <li class="nav-menu-item nav-menu-center">My profile</li>
                <li class="nav-menu-item nav-menu-center nav-menu-seperator" >My product</li>
                <li class="nav-menu-item nav-menu-center" >Program setup</li>
                <li class="nav-menu-item nav-menu-center nav-menu-seperator">Logout</li>
                <li class="nav-menu-item nav-menu-center" style="font-size: 12px;color:#959595">Version 10.117.1</li>
            </ol>
        </div>
    </div>
</div>